module.exports = __webpack_public_path__ + "img/flash_off.20c5350a.svg";